import { Bar, BarChart, Cell, LabelList, ResponsiveContainer, XAxis, YAxis } from "recharts";

const COLORS = ["#E32118", "#E5A91E", "#0F52BA"];

const toNumber = (value = "") => parseFloat(String(value).replace(/[^0-9.]/g, "")) || 0;

const SHORT = { "England list": "England", "Europe list (excluding England)": "Europe", "USA list": "USA" };

export const ValuationChart = ({ rows = [], total }) => {
  const data = rows.map((r) => ({
    name: SHORT[r.region] || r.region.replace(/ list.*/i, ""),
    value: toNumber(r.value),
    label: r.value,
    detail: r.detail,
  }));

  if (!data.length) return null;

  return (
    <div className="border border-white/10 bg-[#0b0b0b] p-6 md:p-9" data-testid="valuation-chart">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="overline text-ochre">Split by region</p>
          <h2 className="display-3 mt-3">Where the value sits</h2>
        </div>
        {total ? (
          <p className="font-display text-2xl text-ochre md:text-3xl" data-testid="valuation-chart-total">
            {total} total
          </p>
        ) : null}
      </div>

      <div className="mt-9 h-[320px] min-h-[320px] w-full min-w-[280px]">
        <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 600, height: 320 }}>
          <BarChart data={data} margin={{ top: 30, right: 8, bottom: 4, left: 8 }} barCategoryGap="28%">
            <XAxis
              dataKey="name"
              tick={{ fill: "#e4e4e7", fontSize: 13, fontFamily: "Oswald, sans-serif" }}
              axisLine={{ stroke: "#27272a" }}
              tickLine={false}
            />
            <YAxis
              tick={{ fill: "#52525b", fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              tickFormatter={(v) => `$${v}m`}
              width={52}
            />
            <Bar dataKey="value" isAnimationActive animationDuration={1100} radius={[2, 2, 0, 0]}>
              {data.map((d, i) => (
                <Cell key={d.name} fill={COLORS[i % COLORS.length]} />
              ))}
              <LabelList
                dataKey="label"
                position="top"
                fill="#ffffff"
                style={{ fontFamily: "Oswald, sans-serif", fontSize: 18, fontWeight: 700 }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-6 grid gap-4 border-t border-white/10 pt-6 sm:grid-cols-3">
        {data.map((d, i) => (
          <div key={d.name} className="flex items-start gap-3" data-testid={`valuation-legend-${i}`}>
            <span className="mt-1 h-3 w-3 shrink-0" style={{ background: COLORS[i % COLORS.length] }} />
            <span>
              <span className="block font-display text-sm uppercase tracking-wide text-white">{d.name}</span>
              <span className="block text-[0.66rem] uppercase tracking-[0.16em] text-zinc-500">{d.detail}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
